import React from 'react';
import { ShieldCheck } from 'lucide-react';

const PaymentPrivacyDisclosure = ({ children, showGeneral = true }) => (
  <>
    {showGeneral && <div className="mt-4 mb-3 text-center text-white" aria-label="Company registration details">
      <p className="text-sm font-semibold leading-5">PhantomPathVPN Ltd · Company No. 16958507</p>
      <p className="mt-1 text-xs leading-5 text-white/80">ICO Registration No. ZC089271</p>
    </div>}
    <aside className="mt-2 rounded-xl border border-[#2dd4bf]/20 bg-black/20 px-3 py-3 text-center sm:text-left" aria-label="Secure payments separated from VPN activity">
      <div className="flex flex-col items-center gap-2.5 sm:flex-row sm:items-start">
        <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#2dd4bf]" aria-hidden="true" />
        <div className="min-w-0 w-full">
          {showGeneral && <h3 className="text-sm font-semibold text-gray-100">Secure payments. Separate from your VPN activity.</h3>}
          <div className="mt-2 space-y-1.5 text-center text-[11px] leading-5 text-gray-400 sm:text-left sm:text-xs">
            {showGeneral && <>
              <p className="font-medium text-gray-200">Pay using the supported option that suits you, including card payments via Stripe, PayPal, and eligible UK mobile billing.</p>
              <p>You don't need to create a PhantomPath account to use a VPN pass.</p>
              <p>Payment providers process the information they require to complete the transaction. PhantomPath keeps only the limited order information needed for provisioning, accounting, refunds, fraud prevention and support.</p>
              <p>Payment information is not linked to your VPN browsing activity or traffic content.</p>
            </>}
            {children && <div className="mt-2 space-y-1.5 border-t border-white/10 pt-2 text-center">{children}</div>}
          </div>
        </div>
      </div>
    </aside>
  </>
);

export default PaymentPrivacyDisclosure;
